export default __webpack_public_path__ + "static/media/SuperToDo3.ddfdd280.jpg";